/**
 * GENERATED by `pnpm codegen` from `src/quest-v2-api/quest/static/i18n/en.json`.
 * Do not edit — change the API's bundle and regenerate. See `scripts/codegen-i18n.mjs`.
 */

/** Every key `t()` accepts. Counted phrases are `UiPluralKey`, below. */
export type UiKey =
  | "ui.a11y.skip_to_story"
  | "ui.a11y.story_controls"
  | "ui.a11y.turn_updates"
  | "ui.action.injury"
  | "ui.action.item.consumable"
  | "ui.action.item.gear"
  | "ui.action.item.misc"
  | "ui.action.item.weapon"
  | "ui.action.the_item"
  | "ui.app.ai_disclosure"
  | "ui.app.tagline"
  | "ui.app.title"
  | "ui.auth.session_expired"
  | "ui.auth.sign_in"
  | "ui.auth.sign_out"
  | "ui.change.family.body"
  | "ui.change.family.inventory"
  | "ui.change.family.knowledge"
  | "ui.change.family.time"
  | "ui.change.family.vitals"
  | "ui.change.family.world"
  | "ui.change.field.after"
  | "ui.change.field.ammo"
  | "ui.change.field.amount"
  | "ui.change.field.before"
  | "ui.change.field.cause"
  | "ui.change.field.certainty"
  | "ui.change.field.connections"
  | "ui.change.field.day"
  | "ui.change.field.delta"
  | "ui.change.field.description"
  | "ui.change.field.destination"
  | "ui.change.field.display_name"
  | "ui.change.field.fact"
  | "ui.change.field.from"
  | "ui.change.field.from_display_name"
  | "ui.change.field.given"
  | "ui.change.field.hours"
  | "ui.change.field.injury_id"
  | "ui.change.field.item"
  | "ui.change.field.level"
  | "ui.change.field.location"
  | "ui.change.field.merged"
  | "ui.change.field.merged_display_name"
  | "ui.change.field.minutes"
  | "ui.change.field.name"
  | "ui.change.field.new_abilities"
  | "ui.change.field.new_severity"
  | "ui.change.field.quantity"
  | "ui.change.field.received"
  | "ui.change.field.relationship"
  | "ui.change.field.remaining"
  | "ui.change.field.season"
  | "ui.change.field.seconds"
  | "ui.change.field.severity"
  | "ui.change.field.skill"
  | "ui.change.field.source"
  | "ui.change.field.state"
  | "ui.change.field.status"
  | "ui.change.field.terms"
  | "ui.change.field.time_of_day"
  | "ui.change.field.to"
  | "ui.change.field.to_display_name"
  | "ui.change.field.type"
  | "ui.change.field.uses"
  | "ui.change.field.uses_remaining"
  | "ui.change.field.verdict"
  | "ui.change.label"
  | "ui.change.live_label"
  | "ui.change.no_detail"
  | "ui.chapter.dateline_day"
  | "ui.chapter.day_heading"
  | "ui.chapter.load_older"
  | "ui.chapter.loading_older"
  | "ui.chapter.not_yet_written"
  | "ui.chapter.nothing_yet"
  | "ui.chapter.number"
  | "ui.chapter.story_begins"
  | "ui.chapter.what_the_dm_saw"
  | "ui.character.age"
  | "ui.character.age_hint"
  | "ui.character.age_not_a_number"
  | "ui.character.age_out_of_range"
  | "ui.character.begin"
  | "ui.character.create"
  | "ui.character.intro"
  | "ui.character.language"
  | "ui.character.language_hint"
  | "ui.character.name"
  | "ui.character.name_hint"
  | "ui.character.name_missing"
  | "ui.character.name_too_long"
  | "ui.character.sex"
  | "ui.character.sex.female"
  | "ui.character.sex.male"
  | "ui.character.sex.other"
  | "ui.character.waking"
  | "ui.common.cancel"
  | "ui.common.close"
  | "ui.common.just_now"
  | "ui.common.loading"
  | "ui.common.retry"
  | "ui.death.is_dead"
  | "ui.death.new_story"
  | "ui.death.no_epitaph"
  | "ui.death.section_label"
  | "ui.death.stat.chapters"
  | "ui.death.stat.days"
  | "ui.death.stat.people"
  | "ui.death.stat.places"
  | "ui.effects.field.can_perform_physical"
  | "ui.effects.field.failure_chance_increase"
  | "ui.effects.field.healing_multiplier"
  | "ui.effects.field.health_damage_per_hour"
  | "ui.effects.field.skill_penalty"
  | "ui.effects.field.stamina_cost_multiplier"
  | "ui.effects.field.stamina_recovery_multiplier"
  | "ui.error.account_inactive"
  | "ui.error.back_to_start"
  | "ui.error.crash_body"
  | "ui.error.crash_title"
  | "ui.error.empty_narration"
  | "ui.error.forbidden"
  | "ui.error.internal"
  | "ui.error.iteration_cap"
  | "ui.error.malformed_response"
  | "ui.error.network"
  | "ui.error.not_found_body"
  | "ui.error.not_found_title"
  | "ui.error.refused"
  | "ui.error.reload"
  | "ui.error.service_draining"
  | "ui.error.story_already_started"
  | "ui.error.story_completed"
  | "ui.error.story_limit_reached"
  | "ui.error.story_not_found"
  | "ui.error.stream_interrupted"
  | "ui.error.turn_in_progress"
  | "ui.error.unauthenticated"
  | "ui.error.unknown"
  | "ui.error.usage_limit_reached"
  | "ui.error.validation_error"
  | "ui.feedback.category.bug"
  | "ui.feedback.category.feedback"
  | "ui.feedback.category.suggestion"
  | "ui.feedback.legend"
  | "ui.feedback.message"
  | "ui.feedback.report_error"
  | "ui.feedback.send"
  | "ui.feedback.sending"
  | "ui.feedback.sent"
  | "ui.feedback.title"
  | "ui.feedback.trace"
  | "ui.injury.clause"
  | "ui.injury.severity.minor"
  | "ui.injury.severity.moderate"
  | "ui.injury.severity.severe"
  | "ui.leaderboard.empty"
  | "ui.leaderboard.in_language"
  | "ui.leaderboard.longest"
  | "ui.leaderboard.longest_empty"
  | "ui.leaderboard.recent"
  | "ui.leaderboard.recent_empty"
  | "ui.leaderboard.still_out_there"
  | "ui.leaderboard.title"
  | "ui.leaderboard.updated"
  | "ui.nav.character"
  | "ui.nav.feedback"
  | "ui.nav.journal"
  | "ui.nav.leaderboard"
  | "ui.nav.reading"
  | "ui.nav.settings"
  | "ui.nav.stories"
  | "ui.nav.the_wasteland"
  | "ui.nav.world"
  | "ui.nav.your_stories"
  | "ui.offline.notice"
  | "ui.panel.carrying_nothing"
  | "ui.panel.changed"
  | "ui.panel.changed_this_chapter"
  | "ui.panel.condition_steady"
  | "ui.panel.here"
  | "ui.panel.injuries"
  | "ui.panel.inventory"
  | "ui.panel.nothing_broken"
  | "ui.panel.nothing_learned"
  | "ui.panel.nothing_on_you"
  | "ui.panel.places"
  | "ui.panel.reading_state"
  | "ui.panel.since_chapter"
  | "ui.panel.skills"
  | "ui.panel.status_effects"
  | "ui.panel.until_treated"
  | "ui.panel.while_numbers_hold"
  | "ui.reading.face"
  | "ui.reading.face.sans"
  | "ui.reading.face.serif"
  | "ui.reading.measure"
  | "ui.reading.measure.narrow"
  | "ui.reading.measure.normal"
  | "ui.reading.measure.wide"
  | "ui.reading.reset"
  | "ui.reading.sample"
  | "ui.reading.size"
  | "ui.reading.size.huge"
  | "ui.reading.size.large"
  | "ui.reading.size.normal"
  | "ui.reading.size.small"
  | "ui.reading.stored_here"
  | "ui.reading.title"
  | "ui.settings.locale"
  | "ui.settings.locale_hint"
  | "ui.settings.locale_saved"
  | "ui.settings.slots_used"
  | "ui.settings.title"
  | "ui.story.delete"
  | "ui.story.delete_alive"
  | "ui.story.delete_aria"
  | "ui.story.delete_confirm"
  | "ui.story.delete_finished"
  | "ui.story.delete_forever"
  | "ui.story.delete_title"
  | "ui.story.deleted"
  | "ui.story.deleting"
  | "ui.story.died"
  | "ui.story.in_progress"
  | "ui.story.loading"
  | "ui.story.new"
  | "ui.story.none"
  | "ui.story.not_begun"
  | "ui.story.slots_free"
  | "ui.story.slots_full"
  | "ui.time.game_time"
  | "ui.time.of_day.afternoon"
  | "ui.time.of_day.dawn"
  | "ui.time.of_day.evening"
  | "ui.time.of_day.midday"
  | "ui.time.of_day.midnight"
  | "ui.time.of_day.morning"
  | "ui.time.of_day.night"
  | "ui.time.season.fall"
  | "ui.time.season.spring"
  | "ui.time.season.summer"
  | "ui.time.season.winter"
  | "ui.title.page"
  | "ui.title.stories"
  | "ui.turn.action_label"
  | "ui.turn.action_placeholder"
  | "ui.turn.amend"
  | "ui.turn.choices_label"
  | "ui.turn.dismiss"
  | "ui.turn.in_progress"
  | "ui.turn.loading_story"
  | "ui.turn.next_chapter"
  | "ui.turn.phase.narration"
  | "ui.turn.phase.resolution"
  | "ui.turn.reading_action"
  | "ui.turn.recovery.in_flight"
  | "ui.turn.recovery.landed"
  | "ui.turn.recovery.lost"
  | "ui.turn.recovery.pending"
  | "ui.turn.recovery.unknown"
  | "ui.turn.started_at"
  | "ui.turn.still_working"
  | "ui.turn.submit"
  | "ui.turn.wake_up"
  | "ui.vital.health"
  | "ui.vital.hunger"
  | "ui.vital.stamina"
  | "ui.vital.thirst"
  | "ui.world.alone_here"
  | "ui.world.also_here"
  | "ui.world.chapter_ref"
  | "ui.world.factions"
  | "ui.world.facts"
  | "ui.world.held_by"
  | "ui.world.here_now"
  | "ui.world.last"
  | "ui.world.last_known_at"
  | "ui.world.mention.open"
  | "ui.world.never"
  | "ui.world.never_seen"
  | "ui.world.no_factions"
  | "ui.world.no_facts"
  | "ui.world.no_people"
  | "ui.world.no_places"
  | "ui.world.no_rumours"
  | "ui.world.not_dealt_with"
  | "ui.world.npc.dead"
  | "ui.world.npc.missing"
  | "ui.world.npc.unknown"
  | "ui.world.people"
  | "ui.world.places"
  | "ui.world.relationship.allied"
  | "ui.world.relationship.friendly"
  | "ui.world.relationship.hostile"
  | "ui.world.relationship.neutral"
  | "ui.world.relationship.unfriendly"
  | "ui.world.rumours"
  | "ui.world.visit.dangerous"
  | "ui.world.visit.fully_searched"
  | "ui.world.visit.partially_searched"
  | "ui.world.visit.rumoured"
  | "ui.world.visit.safe"
  | "ui.world.visit.unexplored";

/**
 * Keys that need a `count` and resolve through `Intl.PluralRules`. The stored strings are
 * `${family}.plural.${category}`; callers pass the family.
 */
export type UiPluralKey =
  | "ui.item.rounds"
  | "ui.item.uses"
  | "ui.story.chapters"
  | "ui.turn.choices";

/** D7's bundled fallback: a failed `/translations` fetch degrades to English, not to blanks. */
export const EN: Readonly<Record<string, string>> = {
  "ui.a11y.skip_to_story": "skip to the story",
  "ui.a11y.story_controls": "Story controls",
  "ui.a11y.turn_updates": "Turn updates",
  "ui.action.injury": "tend to my {location}",
  "ui.action.item.consumable": "use {item}",
  "ui.action.item.gear": "get out {item}",
  "ui.action.item.misc": "take a closer look at {item}",
  "ui.action.item.weapon": "ready {item}",
  "ui.action.the_item": "the {item}",
  "ui.app.ai_disclosure": "Your Dungeon Master is an AI — Claude, by Anthropic. Everything it writes is generated.",
  "ui.app.tagline": "Survive one more chapter.",
  "ui.app.title": "Wasteland",
  "ui.auth.session_expired": "Your session expired. Sign in again and you will land back where you were — nothing in your story was lost.",
  "ui.auth.sign_in": "Sign in",
  "ui.auth.sign_out": "sign out",
  "ui.change.family.body": "Body",
  "ui.change.family.inventory": "Inventory",
  "ui.change.family.knowledge": "Knowledge",
  "ui.change.family.time": "Time",
  "ui.change.family.vitals": "Vitals",
  "ui.change.family.world": "World",
  "ui.change.field.after": "after",
  "ui.change.field.ammo": "rounds",
  "ui.change.field.amount": "amount",
  "ui.change.field.before": "before",
  "ui.change.field.cause": "cause",
  "ui.change.field.certainty": "certainty",
  "ui.change.field.connections": "routes",
  "ui.change.field.day": "day",
  "ui.change.field.delta": "change",
  "ui.change.field.description": "description",
  "ui.change.field.destination": "left at",
  "ui.change.field.display_name": "name",
  "ui.change.field.fact": "fact",
  "ui.change.field.from": "from",
  "ui.change.field.from_display_name": "from",
  "ui.change.field.given": "given",
  "ui.change.field.hours": "hours",
  "ui.change.field.injury_id": "injury id",
  "ui.change.field.item": "item",
  "ui.change.field.level": "level",
  "ui.change.field.location": "body location",
  "ui.change.field.merged": "merged key",
  "ui.change.field.merged_display_name": "merged name",
  "ui.change.field.minutes": "minutes",
  "ui.change.field.name": "key",
  "ui.change.field.new_abilities": "new abilities",
  "ui.change.field.new_severity": "new severity",
  "ui.change.field.quantity": "quantity",
  "ui.change.field.received": "received",
  "ui.change.field.relationship": "relationship",
  "ui.change.field.remaining": "remaining",
  "ui.change.field.season": "season",
  "ui.change.field.seconds": "seconds",
  "ui.change.field.severity": "severity",
  "ui.change.field.skill": "skill",
  "ui.change.field.source": "source",
  "ui.change.field.state": "state",
  "ui.change.field.status": "status",
  "ui.change.field.terms": "terms",
  "ui.change.field.time_of_day": "time of day",
  "ui.change.field.to": "to",
  "ui.change.field.to_display_name": "to",
  "ui.change.field.type": "type",
  "ui.change.field.uses": "uses",
  "ui.change.field.uses_remaining": "uses left",
  "ui.change.field.verdict": "verdict",
  "ui.change.label": "What changed",
  "ui.change.live_label": "Changes, as they happen",
  "ui.change.no_detail": "no further detail",
  "ui.chapter.dateline_day": "Day {day}, {time_of_day}",
  "ui.chapter.day_heading": "Day {day}",
  "ui.chapter.load_older": "earlier chapters",
  "ui.chapter.loading_older": "loading earlier chapters…",
  "ui.chapter.not_yet_written": "not yet written",
  "ui.chapter.nothing_yet": "Nothing has happened yet.",
  "ui.chapter.number": "Chapter {chapter}",
  "ui.chapter.story_begins": "the story begins here",
  "ui.chapter.what_the_dm_saw": "what the DM saw",
  "ui.character.age": "Age",
  "ui.character.age_hint": "{min}–{max}.",
  "ui.character.age_not_a_number": "Give a whole number of years.",
  "ui.character.age_out_of_range": "Between {min} and {max}.",
  "ui.character.begin": "step into the wasteland",
  "ui.character.create": "Who are you?",
  "ui.character.intro": "You wake at the edge of the wasteland with a knife, a tin and a bottle. Nothing else about you is decided.",
  "ui.character.language": "Language",
  "ui.character.language_hint": "The DM speaks this for the whole run. It cannot be changed later.",
  "ui.character.name": "Name",
  "ui.character.name_hint": "Up to {max} letters.",
  "ui.character.name_missing": "Your character needs a name.",
  "ui.character.name_too_long": "Names are at most {max} letters.",
  "ui.character.sex": "Sex",
  "ui.character.sex.female": "female",
  "ui.character.sex.male": "male",
  "ui.character.sex.other": "other",
  "ui.character.waking": "waking up…",
  "ui.common.cancel": "cancel",
  "ui.common.close": "close",
  "ui.common.just_now": "just now",
  "ui.common.loading": "Loading…",
  "ui.common.retry": "try again",
  "ui.death.is_dead": "{name} is dead",
  "ui.death.new_story": "begin a new story",
  "ui.death.no_epitaph": "This story is over.",
  "ui.death.section_label": "The end of this story",
  "ui.death.stat.chapters": "chapters",
  "ui.death.stat.days": "days survived",
  "ui.death.stat.people": "people met",
  "ui.death.stat.places": "places found",
  "ui.effects.field.can_perform_physical": "can perform physical",
  "ui.effects.field.failure_chance_increase": "failure chance increase",
  "ui.effects.field.healing_multiplier": "healing",
  "ui.effects.field.health_damage_per_hour": "health damage per hour",
  "ui.effects.field.skill_penalty": "skill",
  "ui.effects.field.stamina_cost_multiplier": "stamina cost",
  "ui.effects.field.stamina_recovery_multiplier": "stamina recovery",
  "ui.error.account_inactive": "Your account is not active yet.",
  "ui.error.back_to_start": "back to the start",
  "ui.error.crash_body": "Your story is safe — nothing here writes to the server. This is the page failing to draw itself.",
  "ui.error.crash_title": "Something in the interface broke",
  "ui.error.empty_narration": "The turn produced no narration. Nothing was saved — try again.",
  "ui.error.forbidden": "You are not allowed to do that.",
  "ui.error.internal": "Something broke on our side.",
  "ui.error.iteration_cap": "The turn ran too long and was stopped. Nothing was saved — try again.",
  "ui.error.malformed_response": "The server sent something this client could not read.",
  "ui.error.network": "Could not reach the server. Check your connection.",
  "ui.error.not_found_body": "That path does not lead anywhere.",
  "ui.error.not_found_title": "Nothing here",
  "ui.error.refused": "The Dungeon Master declined to resolve that action. Try describing something else.",
  "ui.error.reload": "reload the page",
  "ui.error.service_draining": "The server is restarting. Try that again in a moment.",
  "ui.error.story_already_started": "This story has already begun.",
  "ui.error.story_completed": "This character is dead. Their story is read-only now.",
  "ui.error.story_limit_reached": "You have used every story slot on your account. Delete a finished story to start a new one.",
  "ui.error.story_not_found": "That story does not exist, or it is not yours.",
  "ui.error.stream_interrupted": "The connection dropped while the turn was resolving. It is probably still finishing — do not act again.",
  "ui.error.turn_in_progress": "A turn is still being resolved. It will finish on its own — do not act twice.",
  "ui.error.unauthenticated": "Your session expired. Sign in again to continue.",
  "ui.error.unknown": "Something went wrong.",
  "ui.error.usage_limit_reached": "You have played enough for now. Come back later.",
  "ui.error.validation_error": "That request was not valid.",
  "ui.feedback.category.bug": "Bug",
  "ui.feedback.category.feedback": "Feedback",
  "ui.feedback.category.suggestion": "Suggestion",
  "ui.feedback.legend": "What kind of thing is this?",
  "ui.feedback.message": "What happened?",
  "ui.feedback.report_error": "report this",
  "ui.feedback.send": "send",
  "ui.feedback.sending": "sending…",
  "ui.feedback.sent": "Thank you — that arrived.",
  "ui.feedback.title": "send feedback",
  "ui.feedback.trace": "This report carries the error's trace id — {request_id}",
  "ui.injury.clause": "{severity} {name}, {location}",
  "ui.injury.severity.minor": "Minor",
  "ui.injury.severity.moderate": "Moderate",
  "ui.injury.severity.severe": "Severe",
  "ui.item.rounds.plural.one": "1 round",
  "ui.item.rounds.plural.other": "{count} rounds",
  "ui.item.uses.plural.one": "1 use",
  "ui.item.uses.plural.other": "{count} uses",
  "ui.leaderboard.empty": "Nobody has died yet. The board is written the first time a character does.",
  "ui.leaderboard.in_language": "in {language}",
  "ui.leaderboard.longest": "the longest surviving",
  "ui.leaderboard.longest_empty": "No finished runs to rank.",
  "ui.leaderboard.recent": "the recently fallen",
  "ui.leaderboard.recent_empty": "Nobody has died yet. Someone will.",
  "ui.leaderboard.still_out_there": "still out there",
  "ui.leaderboard.title": "Leaderboard",
  "ui.leaderboard.updated": "Updated {when}.",
  "ui.nav.character": "character",
  "ui.nav.feedback": "feedback",
  "ui.nav.journal": "journal",
  "ui.nav.leaderboard": "leaderboard",
  "ui.nav.reading": "reading",
  "ui.nav.settings": "settings",
  "ui.nav.stories": "stories",
  "ui.nav.the_wasteland": "the wasteland",
  "ui.nav.world": "world",
  "ui.nav.your_stories": "your stories",
  "ui.offline.notice": "You appear to be offline. A turn already running still finishes on the server.",
  "ui.panel.carrying_nothing": "You are carrying nothing.",
  "ui.panel.changed": "changed",
  "ui.panel.changed_this_chapter": "changed this chapter",
  "ui.panel.condition_steady": "Holding together.",
  "ui.panel.here": "here",
  "ui.panel.injuries": "injuries",
  "ui.panel.inventory": "inventory",
  "ui.panel.nothing_broken": "Nothing broken.",
  "ui.panel.nothing_learned": "Nothing learned yet.",
  "ui.panel.nothing_on_you": "Nothing on you.",
  "ui.panel.places": "places",
  "ui.panel.reading_state": "Reading the state…",
  "ui.panel.since_chapter": "since chapter {chapter}",
  "ui.panel.skills": "skills",
  "ui.panel.status_effects": "conditions",
  "ui.panel.until_treated": "Until treated",
  "ui.panel.while_numbers_hold": "While the numbers hold",
  "ui.reading.face": "Narration face",
  "ui.reading.face.sans": "sans",
  "ui.reading.face.serif": "serif",
  "ui.reading.measure": "Line width",
  "ui.reading.measure.narrow": "narrow",
  "ui.reading.measure.normal": "normal",
  "ui.reading.measure.wide": "wide",
  "ui.reading.reset": "reset",
  "ui.reading.sample": "The wind comes off the flats carrying grit and the smell of rust, and somewhere behind you a door you did not close moves in it.",
  "ui.reading.size": "Text size",
  "ui.reading.size.huge": "huge",
  "ui.reading.size.large": "large",
  "ui.reading.size.normal": "normal",
  "ui.reading.size.small": "small",
  "ui.reading.stored_here": "Kept on this device only.",
  "ui.reading.title": "reading",
  "ui.settings.locale": "Language",
  "ui.settings.locale_hint": "This is the interface language and the default for a new story. Stories keep the language they were created in.",
  "ui.settings.locale_saved": "Language saved.",
  "ui.settings.slots_used": "{used} of {max} story slots used.",
  "ui.settings.title": "Settings",
  "ui.story.chapters.plural.one": "1 chapter",
  "ui.story.chapters.plural.other": "{count} chapters",
  "ui.story.delete": "delete",
  "ui.story.delete_alive": "still alive",
  "ui.story.delete_aria": "Delete {name}'s story",
  "ui.story.delete_confirm": "Delete {name}? This cannot be undone.",
  "ui.story.delete_finished": "already finished",
  "ui.story.delete_forever": "delete forever",
  "ui.story.delete_title": "delete story",
  "ui.story.deleted": "{name}'s story was deleted.",
  "ui.story.deleting": "deleting…",
  "ui.story.died": "died",
  "ui.story.in_progress": "in progress",
  "ui.story.loading": "Loading your stories…",
  "ui.story.new": "new story",
  "ui.story.none": "No stories yet.",
  "ui.story.not_begun": "not yet begun",
  "ui.story.slots_free": "{remaining} of {max} story slots free.",
  "ui.story.slots_full": "All {max} story slots are used. Delete a finished story to start a new one.",
  "ui.time.game_time": "Day {day}, {time_of_day} · {season}",
  "ui.time.of_day.afternoon": "afternoon",
  "ui.time.of_day.dawn": "dawn",
  "ui.time.of_day.evening": "evening",
  "ui.time.of_day.midday": "midday",
  "ui.time.of_day.midnight": "midnight",
  "ui.time.of_day.morning": "morning",
  "ui.time.of_day.night": "night",
  "ui.time.season.fall": "fall",
  "ui.time.season.spring": "spring",
  "ui.time.season.summer": "summer",
  "ui.time.season.winter": "winter",
  "ui.title.page": "{page} — {app}",
  "ui.title.stories": "Your stories",
  "ui.turn.action_label": "Your action",
  "ui.turn.action_placeholder": "or say what you do",
  "ui.turn.amend": "edit “{choice}” before doing it",
  "ui.turn.choices.plural.one": "1 option",
  "ui.turn.choices.plural.other": "{count} options",
  "ui.turn.choices_label": "What you could do",
  "ui.turn.dismiss": "dismiss",
  "ui.turn.in_progress": "A turn is still resolving. It will finish on its own — do not act twice.",
  "ui.turn.loading_story": "Loading the story…",
  "ui.turn.next_chapter": "The next chapter",
  "ui.turn.phase.narration": "Writing the scene",
  "ui.turn.phase.resolution": "Working out what happens",
  "ui.turn.reading_action": "The Dungeon Master is reading your action.",
  "ui.turn.recovery.in_flight": "The server confirms the turn is still resolving. It will appear here when it lands.",
  "ui.turn.recovery.landed": "The turn landed. Loading it…",
  "ui.turn.recovery.lost": "The turn never ran.",
  "ui.turn.recovery.pending": "Checking with the server…",
  "ui.turn.recovery.unknown": "The server could not be reached to check. Still trying.",
  "ui.turn.started_at": "Chapter {chapter}, started {time}.",
  "ui.turn.still_working": "still working — the turn finishes on the server even if this page does not see it",
  "ui.turn.submit": "do it",
  "ui.turn.wake_up": "wake up",
  "ui.vital.health": "Health",
  "ui.vital.hunger": "Hunger",
  "ui.vital.stamina": "Stamina",
  "ui.vital.thirst": "Thirst",
  "ui.world.alone_here": "Nobody else is here.",
  "ui.world.also_here": "also here",
  "ui.world.chapter_ref": "chapter {chapter}",
  "ui.world.factions": "factions",
  "ui.world.facts": "facts",
  "ui.world.held_by": "held by: {factions}",
  "ui.world.here_now": "here, now",
  "ui.world.last": "last: {value}",
  "ui.world.last_known_at": "last known at {place}",
  "ui.world.mention.open": "open {name} in the codex",
  "ui.world.never": "never",
  "ui.world.never_seen": "never seen",
  "ui.world.no_factions": "Nobody has claimed anything yet.",
  "ui.world.no_facts": "Nothing settled.",
  "ui.world.no_people": "You have met no one.",
  "ui.world.no_places": "Nowhere but here.",
  "ui.world.no_rumours": "Nothing heard yet.",
  "ui.world.not_dealt_with": "not yet dealt with",
  "ui.world.npc.dead": "dead",
  "ui.world.npc.missing": "missing",
  "ui.world.npc.unknown": "unaccounted for",
  "ui.world.people": "people",
  "ui.world.places": "places",
  "ui.world.relationship.allied": "allied",
  "ui.world.relationship.friendly": "friendly",
  "ui.world.relationship.hostile": "hostile",
  "ui.world.relationship.neutral": "neutral",
  "ui.world.relationship.unfriendly": "unfriendly",
  "ui.world.rumours": "heard",
  "ui.world.visit.dangerous": "dangerous",
  "ui.world.visit.fully_searched": "picked clean",
  "ui.world.visit.partially_searched": "partly searched",
  "ui.world.visit.rumoured": "only heard of",
  "ui.world.visit.safe": "safe",
  "ui.world.visit.unexplored": "never been",
};
